import React from 'react';
import { useTranslation } from 'react-i18next';
import type { AiPromptUseCaseId } from '../../admin/types/AiPromptConfig';
import { ASSIGNABLE_USE_CASES } from '../constants/assignableUseCases';
import styles from './ToolUseCaseAssignment.module.css';

type ToolUseCaseAssignmentProps = {
  selectedUseCaseIds: AiPromptUseCaseId[];
  disabled?: boolean;
  isPublished: boolean;
  onChange: (useCaseIds: AiPromptUseCaseId[]) => void;
};

export const ToolUseCaseAssignment: React.FC<ToolUseCaseAssignmentProps> = ({
  selectedUseCaseIds,
  disabled = false,
  isPublished,
  onChange,
}) => {
  const { t } = useTranslation('tools');

  const toggleUseCase = (useCaseId: AiPromptUseCaseId) => {
    onChange(
      selectedUseCaseIds.includes(useCaseId)
        ? selectedUseCaseIds.filter((id) => id !== useCaseId)
        : [...selectedUseCaseIds, useCaseId],
    );
  };

  return (
    <div className={styles.section}>
      <h4 className={styles.title}>{t('useCaseAssignmentTitle')}</h4>
      <p className={styles.intro}>{t('useCaseAssignmentHelp')}</p>
      <div className={styles.list}>
        {ASSIGNABLE_USE_CASES.map((useCase) => (
          <label key={useCase.id} className={styles.item}>
            <input
              type="checkbox"
              checked={selectedUseCaseIds.includes(useCase.id)}
              disabled={disabled}
              onChange={() => toggleUseCase(useCase.id)}
            />
            <span>
              <strong>{t(useCase.labelKey)}</strong>
              <span>{t(useCase.descriptionKey)}</span>
            </span>
          </label>
        ))}
      </div>
      {!isPublished && selectedUseCaseIds.length > 0 ? (
        <p className={styles.draftHint}>{t('useCaseAssignmentDraftHint')}</p>
      ) : null}
    </div>
  );
};
